/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './accordion.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/shared/accordion/accordion.component';
const styles_AccordionComponent:any[] = [i0.styles];
export const RenderType_AccordionComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AccordionComponent,data:{}});
function View_AccordionComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),7,'div',[['class',
      'panel panel-default']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'div',[['class',
      'panel-heading']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'h4',[['class','panel-title']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'a',[['class','collapse-toggle'],
          ['data-toggle','collapse']],[[1,'data-parent',0],[8,'href',4]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',''])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'div',[['class',
          'panel-collapse collapse']],[[8,'id',0]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
          'panel-body']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = ('#' + _co.parentID);
    const currVal_1:any = ('#' + _co.ids[_v.context.index]);
    _ck(_v,3,0,currVal_0,currVal_1);
    const currVal_2:any = _v.context.$implicit.header;
    _ck(_v,4,0,currVal_2);
    const currVal_3:any = _co.ids[_v.context.index];
    _ck(_v,5,0,currVal_3);
    const currVal_4:any = _v.context.$implicit.content;
    _ck(_v,7,0,currVal_4);
  });
}
export function View_AccordionComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'div',[['class',
      'panel-group']],[[8,'id',0]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AccordionComponent_1)),
      i1.ɵdid(802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any))],(_ck,_v) => {
    var _co:i3.AccordionComponent = _v.component;
    const currVal_1:any = _co.items;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    var _co:i3.AccordionComponent = _v.component;
    const currVal_0:any = _co.parentID;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_AccordionComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-accordion',
      ([] as any[]),(null as any),(null as any),(null as any),View_AccordionComponent_0,
      RenderType_AccordionComponent)),i1.ɵdid(573440,(null as any),0,i3.AccordionComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const AccordionComponentNgFactory:i1.ComponentFactory<i3.AccordionComponent> = i1.ɵccf('admin-accordion',
    i3.AccordionComponent,View_AccordionComponent_Host_0,{items:'items'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2FjY29yZGlvbi9hY2NvcmRpb24uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2FjY29yZGlvbi9hY2NvcmRpb24uY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvYWNjb3JkaW9uL2FjY29yZGlvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2FjY29yZGlvbi9hY2NvcmRpb24uY29tcG9uZW50LnRzLkFjY29yZGlvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJwYW5lbC1ncm91cFwiIFtpZF09XCJwYXJlbnRJRFwiPjxkaXYgY2xhc3M9XCJwYW5lbCBwYW5lbC1kZWZhdWx0XCIgKm5nRm9yPVwibGV0IGl0ZW0gb2YgaXRlbXM7IGxldCBpPWluZGV4XCI+PGRpdiBjbGFzcz1cInBhbmVsLWhlYWRpbmdcIj48aDQgY2xhc3M9XCJwYW5lbC10aXRsZVwiPjxhIGNsYXNzPVwiY29sbGFwc2UtdG9nZ2xlXCIgZGF0YS10b2dnbGU9XCJjb2xsYXBzZVwiIFthdHRyLmRhdGEtcGFyZW50XT1cIicjJyArIHBhcmVudElEXCIgW2hyZWZdPVwiJyMnICsgaWRzW2ldXCI+e3tpdGVtLmhlYWRlcn19PC9hPjwvaDQ+PC9kaXY+PGRpdiBbaWRdPVwiaWRzW2ldXCIgY2xhc3M9XCJwYW5lbC1jb2xsYXBzZSBjb2xsYXBzZVwiPjxkaXYgY2xhc3M9XCJwYW5lbC1ib2R5XCI+e3tpdGVtLmNvbnRlbnR9fTwvZGl2PjwvZGl2PjwvZGl2PjwvZGl2PiIsIjxhZG1pbi1hY2NvcmRpb24+PC9hZG1pbi1hY2NvcmRpb24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7OztvQkNBeUM7TUFBQTtNQUFBLGdCQUF5RTtNQUFBO01BQTJCO1VBQUE7TUFBd0I7VUFBQTtVQUFBLDRDQUE0RztVQUFBLFVBQThCO1VBQUE7VUFBQSxnQkFBbUQ7VUFBQTtNQUF3Qjs7SUFBbks7SUFBb0M7SUFBdEYsV0FBa0QsVUFBb0MsU0FBdEY7SUFBNEc7SUFBQTtJQUFtQztJQUFMLFdBQUssU0FBTDtJQUEyRTtJQUFBOzs7O29CQUExWDtNQUFBO01BQXlDO2FBQUE7NEJBQUE7O0lBQWlDO0lBQWpDLFdBQWlDLFNBQWpDOzs7SUFBaEI7SUFBekIsV0FBeUIsU0FBekI7Ozs7b0JDQUE7TUFBQTttQ0FBQSxVQUFBO01BQUE7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/accordion/accordion.component.ngfactory.ts